import { down } from './down.js'
import { up } from './up.js'

export const localizeStatus = {
  down,
  up,
}

export type { LocalizeStatusArgs } from './up.js'
